import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Pencil, Eye, Loader2 } from "lucide-react";
import { useLanguage } from "../i18n";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../components/ui/dialog";

export const ReviewStep = ({ open, onClose, blocks, onEdit, onConfirm, busy, priceLabel }) => {
  const { t } = useLanguage();
  const r = t.review;
  const [ok, setOk] = useState(false);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="review-dialog" className="bg-cream border-ink/10 rounded-sm max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogTitle className="font-display text-2xl text-ink">{r.title}</DialogTitle>
        <DialogDescription className="text-sm text-inksoft">{r.subtitle}</DialogDescription>
        <div className="mt-4 space-y-3">
          {blocks.map((b) => (
            <div key={b.key} data-testid={`review-block-${b.key}`} className="bg-white border border-ink/10 rounded-sm p-4 flex items-start justify-between gap-4">
              <div className="min-w-0">
                <p className="text-[11px] uppercase tracking-[0.2em] font-semibold text-amberdark">{b.title}</p>
                <dl className="mt-2 grid sm:grid-cols-2 gap-x-6 gap-y-1 text-sm">
                  {b.rows.filter(([, v]) => v).map(([k, v]) => (
                    <div key={k} className="flex gap-2 min-w-0"><dt className="text-inksoft shrink-0 truncate max-w-[45%]">{k}:</dt><dd className="text-ink truncate">{v}</dd></div>
                  ))}
                </dl>
              </div>
              <button type="button" data-testid={`review-edit-${b.key}`} onClick={() => { onClose(); onEdit(b.key); }} className="shrink-0 inline-flex items-center gap-1.5 text-xs font-semibold text-ink border border-ink/20 hover:border-ink rounded-sm px-3 h-8"><Pencil className="w-3.5 h-3.5" />{r.edit}</button>
            </div>
          ))}
        </div>
        <Link to="/progetti" target="_blank" data-testid="review-sample-link" className="mt-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.15em] text-amberdark hover:text-ink"><Eye className="w-4 h-4" />{r.sample}</Link>
        <label className="mt-4 flex items-start gap-3 text-xs leading-relaxed text-ink cursor-pointer border border-ink/10 bg-white rounded-sm p-4">
          <input type="checkbox" data-testid="review-confirm-checkbox" checked={ok} onChange={(e) => setOk(e.target.checked)} className="mt-0.5 w-4 h-4 accent-[#B8875A]" />
          <span>{r.confirmText}</span>
        </label>
        <button type="button" data-testid="review-confirm-button" disabled={!ok || busy} onClick={onConfirm} className="mt-3 w-full inline-flex items-center justify-center gap-2 bg-ink text-cream hover:bg-espresso disabled:opacity-50 rounded-sm h-12 text-xs font-semibold uppercase tracking-[0.15em]">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />}{r.pay} — {priceLabel}
        </button>
      </DialogContent>
    </Dialog>
  );
};
